import { fetchJsonResponse } from './fetchJsonResource';
import NEWSLETTER_RESULT from './newsletterSubscriptionResult';

const ROUTE_NAME = 'evp_ticket_frontend.newsletter_subscribe';
const SERVER_STATUS_INVALID_EMAIL = 'invalid_email';

async function subscribeToNewsletter(email, { signal } = {}) {
    let response;

    try {
        response = await fetchJsonResponse(ROUTE_NAME, undefined, {
            signal,
            method: 'POST',
            body: { email },
        });
    } catch (cause) {
        if (cause.name === 'AbortError') {
            throw cause;
        }

        return NEWSLETTER_RESULT.ERROR;
    }

    if (response.ok) {
        return NEWSLETTER_RESULT.SUCCESS;
    }

    if (response.body && response.body.status === SERVER_STATUS_INVALID_EMAIL) {
        return NEWSLETTER_RESULT.INVALID_EMAIL;
    }

    return NEWSLETTER_RESULT.ERROR;
}

export default subscribeToNewsletter;
export { NEWSLETTER_RESULT, ROUTE_NAME };
